// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { useCallback, useState } from 'react';
import { useResizeObserver } from '@cloudscape-design/component-toolkit/internal';
import { throttle } from '../internal/utils/throttle';
// Minimum scrollable space is the space other than the sticky content, for instance for a sticky footer it's the
// the space other than that, which would be drawer height minus footer height.
export const MINIMUM_SCROLLABLE_SPACE = 148;
const STICKY_STATE_CHECK_THROTTLE_DELAY = 100; // every tenth of a second
export function useStickyFooter({ rootRef, drawerRef, footerRef, }) {
    const [isSticky, setIsSticky] = useState(true);
    const checkStickyState = throttle(useCallback(() => {
        var _a;
        if (!(drawerRef === null || drawerRef === void 0 ? void 0 : drawerRef.current) || !(footerRef === null || footerRef === void 0 ? void 0 : footerRef.current)) {
            return;
        }
        const parentElement = (_a = rootRef === null || rootRef === void 0 ? void 0 : rootRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
        const parentElementHeight = parentElement === null || parentElement === void 0 ? void 0 : parentElement.getBoundingClientRect().height;
        const drawerHeight = drawerRef.current.getBoundingClientRect().height;
        const effectiveHeight = Math.min(parentElementHeight !== null && parentElementHeight !== void 0 ? parentElementHeight : drawerHeight, drawerHeight);
        // take minimum of drawer and parent height
        const footerHeight = footerRef.current.getBoundingClientRect().height;
        const scrollableHeight = effectiveHeight - footerHeight;
        const hasEnoughSpace = scrollableHeight >= MINIMUM_SCROLLABLE_SPACE;
        setIsSticky(hasEnoughSpace);
    }, [rootRef, footerRef, drawerRef]), STICKY_STATE_CHECK_THROTTLE_DELAY);
    useResizeObserver(() => { var _a, _b; return (_b = (_a = rootRef === null || rootRef === void 0 ? void 0 : rootRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) !== null && _b !== void 0 ? _b : null; }, checkStickyState);
    return { isSticky };
}
//# sourceMappingURL=use-sticky-footer.js.map